import {AnyAction, ThunkDispatch} from '@reduxjs/toolkit';
import {handleError} from '@store/app.slice';
import {IError} from './types';


export const helperHandleError = (fc: string, error: any, dispatch: ThunkDispatch<unknown, unknown, AnyAction>): IError => {
    dispatch(handleError(error.response.data));
    throw error;
};
